import { createAddon } from 'Addons/combine';

import initialize from './initialize';

export default createAddon('fitmentSearch', {
  initialize,
});
